import React from 'react';
import { connect } from 'react-redux';
import { isSandboxSelected } from '../../jurisdiction/redux/selectors';
import './SandboxBanner.scss';

/* Shown while a sandbox is selected at the top, so that its simulated players are not taken for real ones. */
const SandboxBannerComponent = ({ sandboxSelected }) =>
    sandboxSelected ? (
        <div className={'sandbox-banner'}>
            <i className={'material-icons'}>science</i>
            <span>
                Sandbox data. Not real players. Alerts here are read-only.
            </span>
        </div>
    ) : null;

export const SandboxBanner = connect(state => ({
    sandboxSelected: isSandboxSelected(state)
}))(SandboxBannerComponent);
